export function initMetaAdSearch() {
  $('#meta-ad-search-clear').off('click').on('click', function(e) {
    $('#meta-ad-search-input').val('')

    const url = new URL(window.location.href);
    url.searchParams.delete('query');
    window.location.href = url.toString();
  });
}

export function initCreativeTypeSelect() {
  $('#creative-type-select').on('change', function(e) {
    const creativeType = $(this).val();
    if (creativeType === 'IMAGE') {
      $('#creative-file-label').text('Upload Image');
      $('#image-file-upload').show();
      $('#image-file-upload').prop('disabled', false);
      $('#video-file-upload').hide();
      $('#video-file-upload').prop('disabled', true);
    } else if (creativeType === 'VIDEO') {
      $('#creative-file-label').text('Upload Video');
      $('#image-file-upload').hide();
      $('#image-file-upload').prop('disabled', true);
      $('#video-file-upload').show();
      $('#video-file-upload').prop('disabled', false);
    }
  });
}
  